import { Component, OnInit, Inject, Injector, Input, ElementRef, ViewChild } from "@angular/core";
import { AppComponentBase } from "../../services/AppComponentBase";
import { ICompetitionData } from "../../interfaces/IcompetitionData";
import { Tournament, TournamentWithAccountId } from "../../api/DixApiClient";
import * as moment from "moment";
import { QuotePanelsTabsList } from "../../enums/QuotePanelsTabs.list";
import { ShowCompetitionRegisterModal } from "../modals/competitionRegistration/show-competition-registration-modal";

@Component({
    selector: "app-competition-information",
    template: require('./competition-information.component.html'),
    styles: [require('./competition-information.component.scss')]
})
export class CompetitionInformationComponent extends AppComponentBase implements OnInit {
    @Input() public competition!: TournamentWithAccountId;
    @Input() public isUser!: boolean;
    @ViewChild("competitionPan") public competitionPan!: ElementRef;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.afterLoadCompetiton();
    }

    public countentUnits: string = "Days | Hours | Minutes | Seconds";
    public endCountdownDate: string = "April 01, 2019";

    public calculateScale() {
        let w = this.panelWidth;
        let unit = 476;

        let scale = w / unit;
        return {
            transform: "scale(" + scale + ")"
        };
    }

    public calculateMinHeight() {
        let w = this.panelWidth;
        let unit = 476;

        let scale = w / unit;
        this.workspace.minAdvHeigh = (80 * scale ) + "px";
        return {
            "min-height": 80 * scale + "px"
        };
    }

    get panelWidth() {
        if (this.competitionPan !== undefined) {
            return this.competitionPan.nativeElement.offsetWidth || 476;
        } else {
            return 476;
        }
    }

    public get timezone() {
        return (
            "A" +
            moment.tz.guess() +
            "B" +
            " " +
            this.competition.startDateUtc.tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss") +
            " " +
            this.competition.startDateUtc.utc() +
            " " +
            this.competition.startDateUtc.tz("America/New_York").format("YYYY-MM-DD HH:mm:ss")
        );
        //return moment.tz.guess();
    }

    public get startCompetitionDate(): string {
        return this.competition.startDateUtc.tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss");
    }

    public get endCompetitionDate(): string {
        return this.competition.endDateUtc.tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss");
    }

    public get challengeInProgress(): boolean {
        let today = moment().utc();
        return today.isBetween(moment(this.competition.startDateUtc), moment(this.competition.endDateUtc)); //.format('MMMM D, YYYY');
    }

    private _units: string = "hours";
    public get units(): string {
        return this._units;
    }
    public set units(value: string) {
        this._units = value;
    }

    public get activeAdvertising(): boolean {
        let startAdvertisingShow = this.competition.startAdvertisingDateUtc.utc();
        let endAdvertisingShow = this.competition.endAdvertisingDateUtc.utc();
        let today = moment().utc();
        return today.isBetween(startAdvertisingShow, endAdvertisingShow);
    }

    private afterLoadCompetiton() {
        let startAdvertisingShow = this.competition.startAdvertisingDateUtc.utc();
        let endAdvertisingShow = this.competition.endAdvertisingDateUtc.utc();
        let today = moment().utc();
        let hoursToRepeat: number = this.competition.hoursToRepeat;

        let cookieName: string = "competition"; // + this.competition.id;
        let lastDisplayed: string = this.cookieService.getCookie(cookieName);

        if (today.isBetween(startAdvertisingShow, endAdvertisingShow)) {
            this.workspace
                .getStateLoginTournamentsForUser(this.workspace.userId, this.competition!.id)
                .then(response => {
                    if (response !== null && response.length > 0) {
                        if (response[0].wasLogin == 0) {
                            //  ShowCompetitionRegisterModal(this.modalService, this.competition, false, false,false,true, undefined, this.workspace.mobileMode);
                            //  this.workspace.wasLoginByTournamentUser(this.workspace.userId, this.competition.id,1);
                        }
                    }
                })
                .catch(error => {
                    console.error(error);
                });

            if (lastDisplayed != "") {
                var lastDisplayedDate: moment.Moment = moment(lastDisplayed, "YYYY-MM-DDTHH:mm:ss")
                    .add(hoursToRepeat, "hours")
                    .utc();

                if (today.isAfter(lastDisplayedDate)) {
                    this.canBeDisplayed = true;
                    this.workspace.showSLider = true;
                } else {
                    this.workspace.showSLider = false;
                }
            } else {
                this.canBeDisplayed = true;
                this.workspace.showSLider = true;
            }

            setInterval(() => {
                if (!this.canBeDisplayed) {
                    let now = moment().utc();
                    lastDisplayed = this.cookieService.getCookie(cookieName);
                    lastDisplayedDate = moment(lastDisplayed, "YYYY-MM-DDTHH:mm:ss")
                        .add(hoursToRepeat, "hours")
                        .utc();

                    if (now.isAfter(lastDisplayedDate)) {
                        this.canBeDisplayed = true;
                        this.workspace.showSLider = true;
                    }
                    else
                    {
                        this.workspace.showSLider = false;
                    }
                }
            }, 60 * 1000);
        } else {
            this.canBeDisplayed = false;
            this.workspace.showSLider = false;
        }
    }

    private _replacePngWithVersion: string = ".png?ver=";
    public get replacePngWithVersion(): string {
        return this._replacePngWithVersion + this.workspace.buildNumber;
    }
    public set replacePngWithVersion(value: string) {
        this._replacePngWithVersion = value;
    }

    private _canBeDisplayed: boolean = false;
    public get canBeDisplayed(): boolean {
        return this._canBeDisplayed;
    }
    public set canBeDisplayed(value: boolean) {
        if (value == true) {
            let cookieName: string = "competition"; // + this.competition.id;
            this.cookieService.setCookie(cookieName, "".toString(), 30, "/");
        }

        this._canBeDisplayed = value;
    }

    public get competitionImage(): string | null | undefined {
        return this.competition.largeImage;
    }

    public get competitionInProgressImage(): string | null | undefined {
        return this.competition.inProgressImage;
    }

    public get competitionCounterImage(): string | null | undefined {
        return this.competition.smallImage;
    }

    private _competitionDescription: string | null | undefined = "";
    public get competitionDescription(): string | null | undefined {
        return this.competition.description;
    }

    public hideCompetitionInfo() {
        this.canBeDisplayed = false;
        this.workspace.showSLider = false;
        let cookieName: string = "competition"; // + this.competition.id;
        let lastDisplayed = moment().utc(true);
        this.cookieService.setCookie(cookieName, lastDisplayed.format("YYYY-MM-DDTHH:mm:ss"), 30, "/");
    }

    public showCompeteRegistrationModal() {
        ShowCompetitionRegisterModal(
            this.modalService,
            this.competition,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            this.workspace.mobileMode
        );
    }

    public showCompeteDatailsModal() {
        if (this.competition.viewDetails != null)
            ShowCompetitionRegisterModal(
                this.modalService,
                this.competition,
                true,
                this.isUser,
                undefined,
                undefined,
                undefined,
                this.workspace.mobileMode
            );
    }

    public showLeaderboard() {
        this.workspace.activeTab = QuotePanelsTabsList.LEADERBOARD;
    }
}
